module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAK0lEQVQ4y2NgGBxAu/4/WZhqBvwnE1DPgHOCav/JwYPIgIEPxIFPSEMbAACybJDQLdXDMAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/CR.png
// module id = 1115
// module chunks = 0